import React, { useState, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import Inventory from './components/Inventory';
import Sidebar from './components/Sidebar';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [currentView, setCurrentView] = useState('dashboard');
  const [selectedCloud, setSelectedCloud] = useState(null);
  const [selectedSubsection, setSelectedSubsection] = useState('vm');

  useEffect(() => {
    if (token) {
      setCurrentView('dashboard');
    }
  }, [token]);

  const handleLogin = (newToken) => {
    setToken(newToken);
    setCurrentView('dashboard');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setCurrentView('login');
    setSelectedCloud(null);
    setSelectedSubsection('vm');
  };

  const handleSelectCloud = (cloudId) => {
    setSelectedCloud(cloudId);
    setCurrentView('inventory');
    setSelectedSubsection('vm');
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
    setSelectedCloud(null);
    setSelectedSubsection('vm');
  };

  // Sidebar navigation handler
  const handleSidebarNavigate = (section, subsection) => {
    if (section === 'dashboard') {
      setCurrentView('dashboard');
      setSelectedCloud(null);
      setSelectedSubsection('vm');
    } else if (section === 'inventory') {
      setCurrentView('inventory');
      if (subsection) setSelectedSubsection(subsection);
    } else if (section === 'cost') {
      setCurrentView('cost');
    } else if (section === 'gcr') {
      setCurrentView('gcr');
    }
  };

  // If no token, show login
  if (!token) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LoginPage onLogin={handleLogin} />
      </ThemeProvider>
    );
  }

  // Render appropriate view
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {currentView === 'dashboard' && (
        <Dashboard 
          onSelectCloud={handleSelectCloud}
          onLogout={handleLogout}
        />
      )}
      {(currentView === 'inventory' || currentView === 'cost' || currentView === 'gcr') && selectedCloud && (
        <Box sx={{ display: 'flex' }}>
          <Sidebar
            onNavigate={handleSidebarNavigate}
            selectedSection={currentView}
            selectedSubsection={currentView === 'inventory' ? selectedSubsection : null}
          />
          <Box sx={{ flexGrow: 1 }}>
            {currentView === 'inventory' && (
              <Inventory 
                cloud={selectedCloud}
                onBack={handleBackToDashboard}
                sidebarCategory={selectedSubsection}
              />
            )}
            {currentView === 'cost' && (
              <Box sx={{ p: 4 }}>
                <h2>Cost Governance (Coming Soon)</h2>
              </Box>
            )}
            {currentView === 'gcr' && (
              <Box sx={{ p: 4 }}>
                <h2>GCR (Coming Soon)</h2>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </ThemeProvider>
  );
}

export default App; 